<template>
  <div id="GeneratorOrderPageSearchItemsDetail" class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card-section class="data-card-main grid-layout">
          <div
            v-for="(element, lIndex) in computedInputsTypeElements"
            :key="lIndex"
            :class="getClassesByTheElement(element)"
          >
            <label>{{ element.label }}:</label>
            {{ formatedValue(model[element.name], element) }}
          </div>
        </q-card-section>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'

@Component({
  mixins: [JtCrud.pageDetail],
  name: 'GeneratorOrderPageSearchItemsDetail'
})
class GeneratorOrderPageSearchItemsDetail extends Vue {
}
export default GeneratorOrderPageSearchItemsDetail
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

.full-height{
  padding-top: 40px;
}

for num in 1 .. 12 {
  .col-start-{num} {
    grid-column-start: num;
  }
}

for num in 1 .. 13 {
  .col-end-{num} {
    grid-column-end: num;
  }
}

.grid-layout {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-auto-rows: max-content;
}

.data-card-header {
  font-size: 1.3em;
  padding: 10px 17px 0px;
}

.data-card-main.q-card__section {
  height: calc(100% - 65px);
  overflow: hidden;
  padding: 15px 0;
}

.data-card-main.q-card__section > div {
  padding: 5px 12px;
}

.data-card-main.q-card__section > div > label {
  font-weight: bold;
}

.row-grey {
  background: $ice;
}
</style>
